export default import.meta.ROLLDOWN_FILE_URL_l_l4gWSIg7Fg90WkEXHA5g